export default {
  fetchUser: '/api/me',
  requestSignOut: '/api/auth/logout',
  validateAuthToken: '/api/auth/refresh',
  fetchJWTToken: '/auth/login/xauth-token',
  fetchEsignCredits: '/api/db/esignCredits',
  fetchAuthProfile: '/auth/v2/users/profile',
  fetchFeatureConfig: '/api/v2.1/stamp/config',
  fetchUserAccessTags: '/api/v2.1/feature/access',
  fetchLoginAccessTags: '/api/v2/login/accessTags',
  fetchUserImpersonators: '/api/v2.1/organization/filters',
  fetchWorkflowBuilderConfig: '/api/v2.1/workflow-builder/config',
};
